import React from 'react'
import { TextField } from '@mui/material'
import { useTranslation } from 'react-i18next'
import SubSettingsArea from 'components/SubSettingsArea'
import { useAtom, useAtomValue } from 'jotai'
import { promptAtom, isDevEnabledAtom } from 'atoms'

const PromptSettings = () => {
  const { t } = useTranslation()
  const [prompt, setPrompt] = useAtom(promptAtom)
  const isDevEnabled = useAtomValue(isDevEnabledAtom)

  // Handler to update the state when text is modified
  const handlePromptChange = (event) => setPrompt(event.target.value)

  if (!isDevEnabled) return null

  return (
    <>
      <SubSettingsArea text={t('promptPhraseConversion')}>
        <TextField
          multiline
          rows={24} // Adjust the number of rows
          fullWidth
          variant="outlined"
          value={prompt} // Wait for API data or fallback to empty
          onChange={handlePromptChange} // Update when modified
        />
      </SubSettingsArea>
    </>
  )
}

export default PromptSettings
